<script setup>
import Select from 'primevue/select'; // PrimeVue Select 컴포넌트 import
import { computed, onMounted, ref, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    inputId: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    selectAll: {
        // 사용하지 않는 prop 제거
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    marginTop: {
        type: String,
        default: '0'
    },
    marginBottom: {
        type: String,
        default: '0'
    },
    marginLeft: {
        type: String,
        default: '0'
    },
    marginRight: {
        type: String,
        default: '0'
    },
    labelRightmargin: {
        type: String,
        default: '2rem'
    },
    options: {
        // options prop은 사용하지 않음
        type: Array,
        default: () => []
    },
    visible: {
        type: Boolean,
        default: true
    },
    width: {
        type: String,
        default: '12.5rem'
    },
    placeholder: {
        type: String,
        default: ''
    },
    readonly: {
        type: Boolean,
        default: false
    },
    errmsg: {
        type: String,
        default: ''
    }
});
const selectWidth = computed(() => props.width || '12.5rem');
const isReadonly = computed(() => props.readonly);
const emit = defineEmits(['update:modelValue', 'input', 'enter', 'change', 'update-options']); // update-options emit 제거
const selectedValue = ref(props.modelValue);
const items = ref([]); // options을 저장할 ref
const errMessage = ref(props.errmsg);
const ValidationMsg = ref('');

// 시간을 생성하는 함수
const generateTimeOptions = () => {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
        times.push({ value: `${String(hour).padStart(2, '0')}:00`, label: `${String(hour).padStart(2, '0')}:00` });
        times.push({ value: `${String(hour).padStart(2, '0')}:30`, label: `${String(hour).padStart(2, '0')}:30` });
    }
    return times;
};

watch(
    () => props.modelValue,
    (newValue) => {
        selectedValue.value = newValue === null || newValue === undefined ? '' : newValue.toString();
    },
    { deep: true }
);

watch(
    () => props.errmsg,
    (newVal) => {
        ValidationMsg.value = newVal || '';
        errMessage.value = newVal || '';
    },
    { immediate: true, deep: true }
);

const onChange = (event) => {
    ValidationMsg.value = '';
    const value = event.value.toString();
    selectedValue.value = value;
    const selectedOption = items.value.find((item) => item.value === value); //여기 수정

    emit('change', {
        id: props.inputId,
        value: value
        //label: selectedOption ? selectedOption.value : value // 여기 주석처리 또는 삭제
    });

    emit('update:modelValue', value);
};

onMounted(() => {
    // 컴포넌트가 마운트될 때 시간 옵션 생성
    items.value = generateTimeOptions();

    //   // 초기값 설정 (props.modelValue가 있으면 해당 값으로, 없으면 빈 문자열)
    // if (props.modelValue) {
    //      selectedValue.value = props.modelValue.toString();
    //  } else {
    //     selectedValue.value = '';
    //  }
});

const getValueForTitle = (value) => {
    const item = items.value.find((item) => item.value === value);
    return item ? item.label : ''; // label을 반환하도록 수정
};

const clearInput = () => {
    selectedValue.value = '';
    emit('input', { id: props.inputId, value: '' });
    emit('update:modelValue', '');
};

const emptyMessage = computed(() => {
    return props.label ? `${props.label}에 등록된 항목이 없습니다.` : '등록된 항목이 없습니다.';
});

const itemCount = computed(() => items.value.length);
</script>

<template>
    <div v-if="visible" class="flex flex-col" :style="{ marginTop, marginBottom, marginLeft, marginRight }">
        <!-- <label :class="['label-font mb-1 mx-1', required ? 'label-required' : 'text-gray-700 dark:text-gray-300']">
            {{ label }}
            <span v-if="required" class="required-asterisk">*</span>
            <span v-if="ValidationMsg" class="validation-message">{{ ValidationMsg }}</span>
        </label> -->
        <div class="custom-select">
            <Select
                :id="inputId"
                v-model="selectedValue"
                :options="items"
                optionLabel="label"
                optionValue="value"
                :title="getValueForTitle(selectedValue)"
                :disabled="isReadonly"
                @change="onChange"
                class="no-border"
                :placeholder="props.placeholder === '' ? '선택하세요.' : props.placeholder"
            >
                <template #empty>
                    {{ emptyMessage }}
                </template>
                <!-- <template #footer>
                    <div class="dropdown-footer">Total {{ items.length }}</div>
                </template> -->
            </Select>
            <!-- <button v-if="selectedValue && !isReadonly" @click="clearInput" class="clear-button">&times;</button> -->
        </div>
    </div>
</template>

<style scoped>
.no-border {
    border-color: transparent !important;
    border: none !important; /* !important 추가 */
}

.label-font {
    font-family: 'SCoreDream600';
    height: 1.3rem;
    /* font-size: 0.875rem; */
}

.required-asterisk {
    color: #f87171; /* 빨간색 */
    margin-left: 0.2rem;
    position: relative;
    top: -0.2rem;
}

.custom-select {
    position: relative;
}
.error-border {
    border-color: #f87171 !important; /* 빨간색 테두리 */
}
.readonly-Bg {
    background-color: whitesmoke !important;
}
.custom-select-input {
    width: 100%;
    background-color: transparent;
    border-radius: 0.5rem;
    border: none;
    cursor: pointer;
}

.custom-select :deep(.p-select) {
    font-size: 1.1rem;
    font-family: 'SCoreDream400';
    background-color: transparent;
    border: none;
    width: 7rem;
}

/* .custom-select :deep(.p-inputtext) {
    width: 100%;
    height: 3rem;
    padding: 0.75rem 2.5rem 0.75rem 1rem;
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    transition:
        border-color 0.2s,
        box-shadow 0.2s;
} */
.custom-select :deep(.p-inputwrapper-focus) {
    border-color: #0038ea !important;
}

.custom-select :deep(.p-select-label) {
    font-size: 1.1rem;
    font-family: 'SCoreDream400';
    height: 2.5rem;
    color: black;
    display: flex;
    align-items: center; /* 상하 중앙정렬 */
}

.custom-select :deep(.p-dropdown-item) {
    padding: 0.5rem;
    display: flex;
    align-items: center; /* 상하 중앙정렬 */
}

.validation-message {
    color: #f87171; /* red-500 */
    font-size: 0.75rem;
    margin-left: 0.5rem;
}

.dropdown-footer {
    font-size: 0.8rem;
    color: gray;
    padding: 0.2rem;
    text-align: right;
    /* border-top: 0.1rem solid #d1d5db; */
    margin-right: 0.5rem;
}
.clear-button {
    position: absolute;
    right: 2.5rem; /* AutoComplete의 드롭다운 아이콘을 고려한 위치 */
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    width: 1.6rem;
    height: 1.6rem;
    font-family: 'SCoreDream400';
    font-size: 1.4rem;
    background: transparent;
    border: none;
    opacity: 0.5;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1; /* AutoComplete 컴포넌트 위에 표시되도록 */
}

.clear-button:hover {
    font-family: 'SCoreDream500';
    opacity: 1;
}

.custom-select :deep(.p-component) {
    box-shadow: none !important;
    border: none !important;
    outline: none !important;
}

.custom-select :deep(.p-inputtext:enabled:focus) {
    box-shadow: none !important;
    border: none !important;
    outline: none !important;
}

.custom-select :deep(.p-inputtext) {
    border: none !important;
    box-shadow: none !important;
}

/* .custom-select :deep(.p-dropdown) {
  border: none !important;
  box-shadow: none !important;
}

.custom-select :deep(.p-dropdown-trigger) {
  border: none !important;
} */

/* 포커스 상태에서도 테두리 제거 */
.custom-select :deep(.p-inputwrapper-focus) {
    border-color: transparent !important;
    box-shadow: none !important;
}
</style>
